import React, { useState } from "react";

const Form = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    address: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
  };

  return (
    <section className="py-4"> {/* section ka padding kam kiya */}
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-6 w-75">
            <div className="card shadow-lg border-0 rounded-4 p-4"> {/* p-5 → p-4 */}
              <h3 className="mb-3 fw-bold text-center text-[#212529]">Get in Touch</h3> {/* mb-4 → mb-3 */}
              <form onSubmit={handleSubmit}>
                {/* Name */}
                <div className="mb-4"> {/* mb-3 → mb-2 */}
                  {/* <label htmlFor="name" className="form-label fw-semibold">
                    Name*
                  </label> */}
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    name="name"
                    placeholder="Enter your name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Email */}
                <div className="mb-4"> {/* mb-3 → mb-2 */}
                  {/* <label htmlFor="email" className="form-label fw-semibold">
                    Email*
                  </label> */}
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Contact */}
                <div className="mb-4"> {/* mb-3 → mb-2 */}
                  {/* <label htmlFor="contact" className="form-label fw-semibold">
                    Contact*
                  </label> */}
                  <input
                    type="tel"
                    className="form-control"
                    id="contact"
                    name="contact"
                    placeholder="Enter your contact number"
                    value={formData.contact}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Address */}
                <div className="mb-4x"> {/* mb-3 → mb-2 */}
                  {/* <label htmlFor="address" className="form-label fw-semibold">
                    Address*
                  </label> */}
                  <textarea
                    className="form-control"
                    id="address"
                    name="address"
                    rows="2"  
                    placeholder="Enter your address"
                    value={formData.address}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                {/* Submit Button */}
                <div className="d-grid mt-3"> {/* mt-4 → mt-3 */}
                  <button
                    type="submit"
                    className="btn btn-lg fw-bold shadow-sm text-white"
                    style={{ backgroundColor: "#02132f" }}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
    </section>
  );
};

export default Form;
